import * as HttpService from "../../../../service/HttpService";

/* 查询计划制定表*/

export const getPlanData = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/patrolManagement/getPlanData", params);
};
/* 巡视计划制定的新增方法 */
export const insertPlan = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/patrolManagement/insertPlan", params);
};
/* 巡视计划的编辑方法 */
export const updatePlan = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/patrolManagement/updatePlan", params);
};

/* 巡视计划的删除方法 */
export const delPlan = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/patrolManagement/delPlan", params);
};






/*获取巡视工单表的数据 包含 下拉查询的方法*/
export const getPatrolWorkOrder = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/patrolManagement/getWorkOrderData", params);
};
/*查询巡视部门 */
export const getSysDept = () => {
    return HttpService.post(HttpService.DOMAIN + "/patrolManagement/getSysDept", );
};

/*查询巡视人员 */
export const getBySysUser = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/patrolManagement/getBySysUser", params);
};


/*巡视工单的审核  */
export const process = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/patrolManagement/process", params);
};
/*巡视工单的新增 */
export const addWorkOrder = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/patrolManagement/addWorkOrder", params);
};
/*巡视工单的编辑 */

export const updateWorkOrder = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/patrolManagement/updateWorkOrder", params);
};

/*巡视工单的删除操作 */
export const delWorkOrder = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/patrolManagement/delWorkOrder", params);
};

/*导出巡视工单 */
export const exportExcel = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/patrolManagement/exportExcel", params);
};






/**  //测试 哦哦哦   根据传入的客户id 返回巡视报告的模板  */
export const getDetails = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/patrolManagement/getDetails",params);
};

/** 填好后的模板 存入巡视报告中 */

export const addDetails = (param) => {
    return HttpService.post(HttpService.DOMAIN + "/patrolManagement/addDetails",param);
};

/**  查询巡视报告 **/
export const findDetails = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/patrolManagement/findDetails",params);
};



